import { Link, useLocation } from "react-router-dom";
import { Home, Grid3X3, ShoppingCart, User } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const ITEMS = [
  { path: "/", label: "Home", icon: Home },
  { path: "/products", label: "Shop", icon: Grid3X3 },
  { path: "/cart", label: "Cart", icon: ShoppingCart },
  { path: "/account", label: "Account", icon: User },
];

export default function MobileBottomNav() {
  const { pathname } = useLocation();
  const { cartCount } = useAuth();

  return (
    <nav className="mobile-bottom-nav md:hidden" data-testid="mobile-bottom-nav">
      <div className="flex items-center justify-around px-2">
        {ITEMS.map(item => {
          const isActive = item.path === "/" ? pathname === "/" : pathname.startsWith(item.path);
          return (
            <Link key={item.path} to={item.path} className={`flex flex-col items-center gap-0.5 py-1.5 px-3 rounded-xl transition-all ${isActive ? 'text-cyan-600' : 'text-slate-400'}`} data-testid={`mobile-nav-${item.label.toLowerCase()}`}>
              <div className="relative">
                <item.icon className={`w-5 h-5 ${isActive ? 'stroke-[2.5]' : ''}`} />
                {item.label === "Cart" && cartCount > 0 && (
                  <span className="absolute -top-1.5 -right-2 w-4 h-4 bg-cyan-600 text-white text-[9px] font-bold rounded-full flex items-center justify-center">{cartCount}</span>
                )}
              </div>
              <span className={`text-[10px] ${isActive ? 'font-semibold' : 'font-medium'}`}>{item.label}</span>
              {isActive && <div className="w-4 h-0.5 bg-cyan-600 rounded-full" />}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
